/**
 * Pyramid layout — stacked horizontal bands forming a triangle. The first node is the
 * narrow band at the top; each subsequent node widens toward the base.
 */
import { paletteColor } from '../smartArtUtils';

const PAD = 6;
const SIDE_PAD = 3; // outer left/right padding (%) — small so the base band nearly spans wide containers
const GAP = 1.5;

export const layoutPyramid = (nodes, theme) => {
  const boxes = [];
  const n = nodes.length;
  if (!n) return { boxes, connectors: [] };

  const innerH = 100 - PAD * 2;
  const bandH = (innerH - GAP * (n - 1)) / n;
  const maxW = 100 - SIDE_PAD * 2;
  const minW = maxW * 0.28;

  nodes.forEach((node, i) => {
    // top band narrowest, bottom band widest
    const t = n === 1 ? 1 : i / (n - 1);
    const wPct = minW + (maxW - minW) * t;
    boxes.push({
      nodeId: node.id,
      xPct: (100 - wPct) / 2,
      yPct: PAD + i * (bandH + GAP),
      wPct,
      hPct: bandH,
      shapeType: 'trapezoid',
      fill: paletteColor(theme, i),
      textColor: theme.textColor,
    });
  });

  return { boxes, connectors: [] };
};
